/**
 * Default parameters for vector similarity search across the application.
 * These values are used for embedding-based search with Typesense.
 *
 * Distance threshold determines how similar results must be (lower = more similar).
 * K (neighbors) determines how many results to return.
 *
 * When threshold < 1.0: use distance filtering (only results within threshold)
 * When threshold >= 1.0: use k nearest neighbors (return top K regardless of distance)
 */

export const VECTOR_SEARCH_DEFAULTS: {
  GROUP: { DISTANCE_THRESHOLD: number; K: number };
  CATEGORY: { DISTANCE_THRESHOLD: number; K: number };
  VIDEO: {
    /** Default threshold — used unless "lax" is selected */
    DISTANCE_THRESHOLD_DEFAULT: number;
    /** Looser threshold for broad/conceptual categories */
    DISTANCE_THRESHOLD_LAX: number;
  };
  /** Executed search (hybrid embedding + keyword) */
  SEARCH: {
    DISTANCE_THRESHOLD: number;
  };
} = {
  /** Category group similarity search defaults */
  GROUP: {
    DISTANCE_THRESHOLD: 0.55,
    K: 2,
  },
  /** Category similarity search defaults (within groups) */
  CATEGORY: {
    DISTANCE_THRESHOLD: 0.6,
    K: 8,
  },
  VIDEO: {
    DISTANCE_THRESHOLD_DEFAULT: 0.5,
    DISTANCE_THRESHOLD_LAX: 0.6,
  },
  SEARCH: {
    DISTANCE_THRESHOLD: 0.6,
  },
};
